export default __webpack_public_path__ + "static/hyper-11c4caea8137841dfe3b08574c49b7a4.jpg";